import { Reducer } from 'redux';
import { HomeServiceOrdersState, HomeServiceOrdersTypes } from './types';

const INITIAL_STATE: HomeServiceOrdersState = {
  data: [],
  loading: false,
};

const reducer: Reducer<HomeServiceOrdersState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case HomeServiceOrdersTypes.LOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case HomeServiceOrdersTypes.LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: undefined,
        ...action.payload
      };
    case HomeServiceOrdersTypes.LOAD_FAILURE:
      return {
        ...state,
        data: [],
        loading: false,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
